import { INVOICE } from '../types/invoice.js';
import { INVOICE_ITEM } from '../types/invoice-item.js';
import { PARTY } from '../types/party.js';
import { PRODUCT } from '../types/product.js';
import { PRODUCTION_ORDER } from '../types/production-order.js';
import { PRODUCTION_ORDER_BREAKDOWN } from '../types/production-order-breakdown.js';
import { PRODUCTION_ORDER_MATERIAL } from '../types/production-order-material.js';
import { PRODUCTION_ORDER_STEP } from '../types/production-order-step.js';
import { PURCHASE_ORDER } from '../types/purchase-order.js';
import { PURCHASE_ORDER_ITEM } from '../types/purchase-order-item.js';
import { PURCHASE_ORDER_ITEM_BREAKDOWN } from '../types/purchase-order-item-breakdown.js';
import { SALES_ORDER } from '../types/sales-order.js';
import { SALES_ORDER_ITEM } from '../types/sales-order-item.js';
import { SALES_ORDER_ITEM_BREAKDOWN } from '../types/sales-order-item-breakdown.js';
import { TECHNICAL_SHEET } from '../types/technical-sheet.js';
import { TECHNICAL_SHEET_MATERIAL } from '../types/technical-sheet-material.js';
import { TECHNICAL_SHEET_OVERRIDE } from '../types/technical-sheet-override.js';
import { TECHNICAL_SHEET_OVERRIDE_INPUT } from '../types/technical-sheet-override-input.js';
import { TECHNICAL_SHEET_OVERRIDE_PROCESS } from '../types/technical-sheet-override-process.js';
import { TECHNICAL_SHEET_ROUTE } from '../types/technical-sheet-route.js';
import { TECHNICAL_SHEET_ROUTE_MACHINE } from '../types/technical-sheet-route-machine.js';
import { SAVED_SELECTION } from '../types/saved-selection.js';
import { SIZE_GRID } from '../types/size-grid.js';
import { SIZE_OCCURRENCE } from '../types/size-occurrence.js';
/**
 * Shared version field descriptor — mirrors {@link Versioned}.
 * Spread into entity `fields` for every opt-in versioned business entity.
 */
export const VERSION_FIELD_DESCRIPTOR = {
    name: 'version',
    label: 'Versão',
    type: 'number',
    required: false,
};
/**
 * Entities whose `OrgScopedCrudService` is configured with `versioned: true`
 * (spec 0045 / request 0236). Kept explicit — never inferred from the registry.
 */
export const VERSIONED_ENTITY_NAMES = [
    PRODUCT,
    TECHNICAL_SHEET,
    TECHNICAL_SHEET_OVERRIDE,
    PRODUCTION_ORDER,
    SALES_ORDER,
    PURCHASE_ORDER,
    INVOICE,
    PARTY,
    SAVED_SELECTION,
    SIZE_GRID,
];
/**
 * Child collections of versioned document headers (order / invoice / sheet /
 * override / production-order lines). Must default to NoCache so "Recarregar"
 * after a conflict does not re-serve stale lines that would then overwrite
 * the other user's write (spec 0045).
 */
export const VERSIONED_CHILD_ENTITY_NAMES = [
    SALES_ORDER_ITEM,
    SALES_ORDER_ITEM_BREAKDOWN,
    PURCHASE_ORDER_ITEM,
    PURCHASE_ORDER_ITEM_BREAKDOWN,
    INVOICE_ITEM,
    TECHNICAL_SHEET_MATERIAL,
    TECHNICAL_SHEET_ROUTE,
    TECHNICAL_SHEET_ROUTE_MACHINE,
    TECHNICAL_SHEET_OVERRIDE_INPUT,
    TECHNICAL_SHEET_OVERRIDE_PROCESS,
    PRODUCTION_ORDER_STEP,
    PRODUCTION_ORDER_MATERIAL,
    PRODUCTION_ORDER_BREAKDOWN,
    SIZE_OCCURRENCE,
];
//# sourceMappingURL=_versionField.js.map